
























































import { Component, Vue } from 'vue-property-decorator'
import dataService, { Device, Hardware, SensorProperty } from '../../services/dataService'
import msg from '@/components/Msg.vue'
import { MessageText } from '@/services/data'
import UserForm from '@/views/Settings/UserForm.vue'
import ws, { SocketMsg } from '@/services/socket'
import utility from '@/common/utility'

@Component({
  components: {
    msg,
    UserForm
  }
})
export default class Account extends Vue {
  isLoading = false
  devices: Device[] = []
  message: MessageText = null

  async mounted () {
    this.initSocket()
    await this.loadDevices()
  }

  async loadDevices () {
    const res = await dataService.getDevicesAsync()
    if (res.Result) {
      this.devices = res.Result
    } else {
      await this.$alert(res.Error)
    }
  }

  async deleteDevice (dev: Device) {
    if (await this.$confirm(this.$t('dialog.delConfirm') as string)) {
      const delRes = await dataService.delDeviceAsync(dev.DeviceId)
      if (delRes.Result) {
        utility.removeArrayItem(this.devices, dev)
      } else {
        await this.$alert(delRes.Error)
      }
    }
  }

  async shareDevice (dev: Device) {
    await this.$alert('not implement')
  }

  async rebootDevice (dev: Device) {
    if (await this.$confirm(this.$t('dialog.rebootConfirm') as string)) {
      const delRes = await dataService.rebootDeviceAsync(dev.DeviceId)
      if (!delRes.Result) {
        await this.$alert(delRes.Error)
      }
    }
  }

  GetHasRate (hs: number) {
    if (hs > 1000000) {
      return (hs / 1000000.0).toFixed(1)
    }
    return hs.toString()
  }

  GetAlgorithm (alg: string) {
    if (alg === 'ethash') return 'ETH'
    return alg
  }

  getPropertyValue (property: SensorProperty, unit = '') {
    if (property != null) {
      if (property.ValueStr) {
        if (property.ValueStr.endsWith(unit)) {
          return property.ValueStr
        } else return property.ValueStr + unit
      }
      return property.Value?.toString() + unit
    }
    return 'Not Supported'
  }

  goTo (path: string) {
    this.$router.push(path)
  }

  async msgCallBack (msg: SocketMsg) {
    if (msg.Action === 'hardware-updated') {
      const dev = msg.Content as Device
      const find = this.devices.find(p => p.DeviceUniqueId === dev.DeviceUniqueId)
      if (find != null) {
        find.IsOnline = dev.IsOnline
        find.LastChecked = dev.LastChecked
        find.ClientVersion = dev.ClientVersion
        find.Hardwares = dev.Hardwares
      }
    }
  }

  initSocket () {
    ws.Server.init()
    ws.Server.addMessageCallBack(this.msgCallBack)
  }

  destroyed () {
    ws.Server.removeMessageCallBack(this.msgCallBack)
    console.log('home destroyed')
  }
}
